import React from 'react';
import ErrorComponent from '../reusable/ErrorComponent';
import { ConfigErrorComponent } from '../reusable/ErrorComponent/ErrorComponent';

interface IState {
    [propName: string] : any
}

class ErrorBoundary extends React.Component<any> {
  state = { error: null, errorInfo: null };
  
  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }
  
  render() {
    if (typeof (window.CONFIG) === 'undefined') {
      //@ts-ignore
      return <ConfigErrorComponent/>
    }
    if (this.state.error) {
      //@ts-ignore
      return <ErrorComponent errorTitle={this.state.error && this.state.error.toString()} errorInfo={this.state.errorInfo}/>
    }
    return this.props.children
  }
} 

export default ErrorBoundary;